<template>
  <div class="view-modal position-relative">
    <div class="modal fade viewModal" id="viewModal" tabindex="-1" role="dialog" aria-labelledby="viewModal" aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="viewModalLabel"><b>{{selectedAnnouncement.title}}</b></h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div style="border-style: ridge" class="p-3" >
              <perfect-scrollbar class="scroll-area">
                <div v-html="selectedAnnouncement.text"></div>
              </perfect-scrollbar>
            </div>
            <template>
              <h6 class="mt-6">Those who have acknowledged this announcement</h6>
              <perfect-scrollbar class="scroll-area">
                <ul class="list-group">
                  <li class="list-group-item d-flex justify-content-between">
                    <span><b>Name</b></span>
                    <span><b>Status</b></span>
                  </li>
                  <li v-for="(row2,index2) in staffUsers" :key="index2" class="list-group-item d-flex justify-content-between" :class="{'bg-offwhite' : row2.uid === user.uid}">
                    <span>
                      {{row2.name}}
                    </span>
                    <span class="mr-13">
                        <i v-if="selectedAnnouncement.acknowledgements && selectedAnnouncement.acknowledgements.includes(row2.uid)" class="fa fa-check-circle text-success fs-20"></i>
                        <i v-else class="fa fa-times-circle text-danger fs-20"></i>
                      </span>
                  </li>

                </ul>
              </perfect-scrollbar>
            </template>

          </div>
            <div class="modal-footer">
            <button  type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
              <button v-if="(selectedAnnouncement.acknowledgements && !selectedAnnouncement.acknowledgements.includes(user.uid))" type="button" class="btn btn-primary" @click="acknowledge">Acknowledge</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {db} from "@/firebase/init";
import {PerfectScrollbar} from "vue2-perfect-scrollbar";
import swal from "sweetalert2";

export default {
  name: "announcementModal",
  components: {PerfectScrollbar},
  computed: {
    user() {
      return this.$store.getters.user;
    },
  },
  props: {
    selectedAnnouncement: {
      type: Object,
      required: true
    },},
  data() {
    return {
      staffUsers:[],
    }
  },
  mounted() {
    this.getStaffUsers()
  },
  methods:{
    async getStaffUsers () {
      this.staffUsers = [];
      const query = await db.collection('users').where('userType', 'in', ['admin', 'manager']).get();
      if (query.size) {
        query.forEach(el => {
          const data = el.data();
          this.staffUsers.push({uid: el.id, name: `${data.firstName} ${data.lastName}`, counter: 0})
        })
      }
    },
    async acknowledge () {
      try {
        this.selectedAnnouncement.acknowledgements.push(this.user.uid);
        const getRef = await db.collection('team-announcements').doc(this.selectedAnnouncement.id).get();
        if(getRef.exists) {
          const { acknowledgements} = getRef.data();
          if(acknowledgements.includes(this.user.uid)) {
            swal('Success', 'You have successfully acknowledged the announcement!', 'success')
            return
          }
        }
        await db.collection('team-announcements').doc(this.selectedAnnouncement.id).update({ acknowledgements: this.selectedAnnouncement.acknowledgements})
        // reduce counter in counters document of team-announcements
        const ref = await db.collection('team-announcements').doc('counter').get();
        console.log('counter doc', ref.exists)
        if (ref.exists) {
          const { staffMembers } = ref.data();
          const obj = staffMembers.find(el => el.uid === this.user.uid);
          if (obj && obj.counter > 0) {
            obj.counter -= 1;
          }
          await db.collection('team-announcements').doc(ref.id).update({ staffMembers })
        }
        // await this.getAnnouncements();
        swal('Success', 'You have successfully acknowledged the announcement!', 'success')
      } catch (e) {
        console.log(e.toString())
        swal('Error', 'Something went wrong while acknowledging!!', 'error')
      } finally {
        $("#viewModal").modal('hide');
      }
    },
  }
}

</script>
